var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-symb-dark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symb-dark",
    clipPath: "url(#clip-symb-dark)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_5",
    "data-name": "Subtra\\xE7\\xE3o 5",
    d: "M-2076.274,2453.038q-3.783,6.609-8.085,12.787c-.153.2-.288.395-.423.6A175.426,175.426,0,0,1-2228.006,2541c-96.4,0-174.825-78.455-174.825-174.9s78.429-174.907,174.825-174.907a175.617,175.617,0,0,1,136.522,65.69l-51.535,29.625a116.818,116.818,0,0,0-134.561-26.487,116.921,116.921,0,0,0-67.055,119.686,116.888,116.888,0,0,0,92.806,101.016,116.836,116.836,0,0,0,124.845-56.783l-44.466-25.342a65.7,65.7,0,0,1-73.723,31.129,65.74,65.74,0,0,1-49.126-63.193,65.744,65.744,0,0,1,48.309-63.822,65.7,65.7,0,0,1,74.117,30.178l12.828,21.855,139.365-80.1-12.983-22.25A226.9,226.9,0,0,0-2228,2140C-2352.611,2140-2454,2241.437-2454,2366.1s101.389,226.1,225.995,226.1a226.357,226.357,0,0,0,143.222-51.3v50.29h51.17V2477.564l-20.423-11.739Z",
    transform: "translate(2493 -2109.712)",
    fill: "#002c43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbDark);
export default __webpack_public_path__ + "static/media/symb-dark.2f92410fccbf26e523edadbe0b124ac7.svg";
export { ForwardRef as ReactComponent };